import { getIsBundleDevops } from '@atlassiansox/bxpkit-core';
import styled from '@emotion/styled';
import { isEmpty, map } from 'lodash';
import React from 'react';
import { SideInformationComponentProps } from '../../../../model/side-information-component';
import { Logo } from './component';
import {
  LayoutDefault,
  LayoutDeveloperMode,
  LayoutDevops,
  LayoutFirstImpressions
} from './container';

export default function SideInformationComponent({
  layout = 'default',
  isLoading,
  productKeys,
  edition,
  isExistingSiteFormShown,
  trialDurationExistingSite,
  trialDurationNewSite,
  featuresList,
  imgSource,
  isMobile,
  sideInfoHeader,
  hideLogoContent,
  logoColor,
  socialProof,
  userInfo,
  analyticsTrack,
  switchUserInfo
}: SideInformationComponentProps) {
  const isSideInfoHeader =
    !isEmpty(sideInfoHeader) && sideInfoHeader.length > 0;
  const showListContent = !isEmpty(featuresList);
  const isEdition = !isEmpty(edition);
  const trialTime = isExistingSiteFormShown
    ? trialDurationExistingSite
    : trialDurationNewSite;
  const isTrialTime = !isEmpty(trialTime);
  const devopsLogo = [
    Logo({
      layout,
      logoColor,
      product: {
        product: 'devops',
        imgSource: '',
        edition: '',
        serverDownloadContent: ''
      }
    })
  ];
  const logo = map(productKeys, (key) =>
    Logo({
      layout,
      logoColor,
      product: key
    })
  );
  const isDevopsBundle = getIsBundleDevops(productKeys);

  const productListMsg = {
    id: 'sideInfoComponent.productListMessage',
    defaultMessage: featuresList
  };
  const sideInfoHeaderMsg = {
    id: 'sideInfoComponent.productHeading',
    defaultMessage: sideInfoHeader
  };

  const layoutDefault = () => {
    return (
      <LayoutDefault
        isMobile={isMobile}
        isLoading={isLoading}
        logo={logo}
        isEdition={isEdition}
        edition={edition}
        isTrialTime={isTrialTime}
        trialTime={trialTime}
        showListContent={showListContent}
        productListMsg={productListMsg}
        imgSource={imgSource}
      />
    );
  };

  const layoutDevops = () => {
    return (
      <LayoutDevops
        isMobile={isMobile}
        logo={isDevopsBundle ? devopsLogo : logo}
        logoColor={logoColor}
        showListContent={showListContent}
        productListMsg={productListMsg}
        isSideInfoHeader={isSideInfoHeader}
        sideInfoHeaderMsg={sideInfoHeaderMsg}
        hideLogoContent={hideLogoContent}
        userInfo={userInfo}
        analyticsTrack={analyticsTrack}
        switchUserInfo={switchUserInfo}
        showMultiProduct={!isDevopsBundle}
      />
    );
  };

  const layoutDeveloperMode = () => {
    return (
      <LayoutDeveloperMode
        isMobile={isMobile}
        logo={logo}
        showListContent={showListContent}
        productListMsg={productListMsg}
        isSideInfoHeader={isSideInfoHeader}
        sideInfoHeaderMsg={sideInfoHeaderMsg}
        isEdition={isEdition}
        edition={edition}
      />
    );
  };

  const layoutFirstImpression = () => {
    if (!socialProof) {
      throw new Error('socialProof is null or undefined');
    }

    return (
      <LayoutFirstImpressions
        socialProof={socialProof}
        productListMsg={productListMsg}
      />
    );
  };

  return (
    <Root>
      <InfoComponent>
        {(() => {
          switch (layout) {
            case 'none':
              return <></>;
            case 'devops':
              return layoutDevops();
            case 'developer-mode':
              return layoutDeveloperMode();
            case 'first-impressions':
              return layoutFirstImpression();
            case 'default':
            default:
              return layoutDefault();
          }
        })()}
      </InfoComponent>
    </Root>
  );
}

const Root = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  max-width: 700px;
  font-family: Charlie Text, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto,
    Noto Sans, Ubuntu, Droid Sans, Helvetica Neue, sans-serif;
`;

const InfoComponent = styled.div`
  width: 100%;
`;
